import axios from 'axios';

const BASE = process.env.REACT_APP_BACKEND_URL || '';

const api = axios.create({
    baseURL: BASE + '/api',
    timeout: 30000,
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('dg_admin_token');
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

api.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err?.response?.status === 401) {
            const path = window.location.pathname;
            // Only clear admin session & redirect if on admin routes
            if (path.startsWith('/dharmikdashboard') && path !== '/dharmikdashboard/login') {
                localStorage.removeItem('dg_admin_token');
                localStorage.removeItem('dg_admin_user');
                window.location.href = '/dharmikdashboard/login';
            }
            // For customer routes we don't force-redirect on 401
        }
        return Promise.reject(err);
    }
);

export default api;
